import {OrbitComponentWithState} from '../orbit-component-with-state/orbit-component-with-state';

export class OrbitComponent<TProps = {}> extends OrbitComponentWithState<TProps, {}> {
}


